(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-banner"]) return;
  try {
    
  {
    const COOKIE_NAME = 'floating_banner_dismissed';
    const SELECTOR = '[data-floating-banner]';
    const DAY_MS = 86_400_000;

    const isDismissed = () =>
      document.cookie.split('; ').includes(`${COOKIE_NAME}=1`);

    const dismissFor = (days) => {
      const expires = new Date(Date.now() + days * DAY_MS).toUTCString();
      document.cookie = `${COOKIE_NAME}=1; expires=${expires}; path=/; SameSite=Lax`;
    };

    const controllers = new WeakMap();

    const init = (banner) => {
      if (!banner || controllers.has(banner)) return;

      const delay = Number(banner.dataset.delay) || 0;
      const cookieDays = Number(banner.dataset.cookieDays) || 30;
      const inEditor = window.Shopify?.designMode ?? false;

      if (isDismissed() && !inEditor) {
        banner.remove();
        return;
      }

      const controller = new AbortController();
      controllers.set(banner, controller);
      const { signal } = controller;

      const timer = setTimeout(() => banner.classList.add('is-visible'), delay);
      signal.addEventListener('abort', () => clearTimeout(timer), { once: true });

      banner.querySelector('[data-floating-banner-close]')?.addEventListener(
        'click',
        () => {
          banner.classList.remove('is-visible');
          banner.classList.add('is-dismissed');
          dismissFor(cookieDays);
          controller.abort();
        },
        { signal }
      );
    };

    const bannersIn = (root) => [
      ...(root.matches?.(SELECTOR) ? [root] : []),
      ...root.querySelectorAll(SELECTOR),
    ];

    const initAll = (root = document) => bannersIn(root).forEach(init);

    const teardown = (root) =>
      bannersIn(root).forEach((banner) => {
        controllers.get(banner)?.abort();
        controllers.delete(banner);
      });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', ({ target }) => initAll(target));
    document.addEventListener('shopify:section:unload', ({ target }) => teardown(target));
  }

  } catch(e) { console.error(e); }
})();
})();
